import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

export const isCourseArchived = (course?: Nullable<CourseApiModel>) => {
  return course?.status === 'archived';
};
